// extracted by mini-css-extract-plugin
export default {"copyButton":"copyTemplate_copyButton__HeS8Z"};